// Etiquetas y preview del catálogo de reportes — lógica PURA, sin React.
import type {
    ReportDefinition,
    ReportFormat,
    ReportPeriodicity,
    ReportRunStatus,
} from '@/api/services/retail-wizard/backoffice';

/** Los formatos que el silo sabe generar hoy. `PDF` está en el tipo pero ninguna corrida lo produce. */
const RUNNABLE_FORMATS: ReportFormat[] = ['CSV'];

/**
 * Los formatos que de verdad se pueden pedir. Un botón por un formato que el silo no genera
 * termina en un error que el operador no puede evitar.
 */
export function runnableFormats(formats: ReportFormat[]): ReportFormat[] {
    return formats.filter((format) => RUNNABLE_FORMATS.includes(format));
}

export const PERIODICITY_LABEL: Record<ReportPeriodicity, string> = {
    DAILY: 'Diaria',
    WEEKLY: 'Semanal',
    MONTHLY: 'Mensual',
};

/** Cómo se produce cada periodicidad — es lo que el operador necesita saber antes de pedirla. */
export const PERIODICITY_HINT: Record<ReportPeriodicity, string> = {
    DAILY: 'Cron 06:00-07:15',
    WEEKLY: 'Cron lunes',
    MONTHLY: 'Corrida manual',
};

export const PERIODICITY_CHIP: Record<ReportPeriodicity, string> = {
    DAILY: 'bg-info-soft text-info',
    WEEKLY: 'bg-success-soft text-success',
    MONTHLY: 'bg-warning-soft text-warning',
};

/**
 * Las COLUMNAS que trae cada reporte, nunca filas de ejemplo: una fila de muestra se lee como el
 * contenido real y el operador no puede distinguirla.
 */
export function reportColumns(report: ReportDefinition): string[] {
    switch (report.reportId) {
        case 'RVL-01':
            return ['periodo', 'ventas_total', 'contado', 'credito', 'ticket_prom'];
        case 'RVL-02':
            return ['tienda_id', 'tienda', 'ventas_semana', 'vs_semana_prev'];
        case 'RVL-03':
            return ['vendedor_id', 'vendedor', 'tienda', 'piezas', 'monto', 'ticket_prom'];
        case 'RVL-04':
            return ['sku', 'producto', 'piezas', 'monto', 'pct_mix'];
        case 'RVL-05':
            return ['financiera', 'ventas_mes', 'monto_total', 'pct_mix'];
        default:
            // Un reporte que el front no conoce: se dice, no se inventan columnas plausibles.
            return [];
    }
}

/** `1,204` — miles con separador mexicano. */
export function formatInt(value: number): string {
    return value.toLocaleString('es-MX');
}

/** Cómo terminó una corrida. `QUEUED` está reservado en el silo y hoy no se emite. */
export const RUN_STATUS_LABEL: Record<ReportRunStatus, string> = {
    QUEUED: 'En cola',
    RUNNING: 'Generando',
    READY: 'Lista',
    FAILED: 'Falló',
};

export const RUN_STATUS_CHIP: Record<ReportRunStatus, string> = {
    QUEUED: 'bg-muted text-muted-foreground',
    RUNNING: 'bg-info-soft text-info',
    READY: 'bg-success-soft text-success',
    FAILED: 'bg-destructive/10 text-destructive',
};
